
var Model = require("../types/Model.js");
var Set = require("es6-set");
var isObject = require("isobject");
var Promise = require("promise");
var not = require("not");

var MAX_AT_ONCE = 300;

module.exports = Model({
	name: "livechatlatestmessages",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	refresh: refresh,
	listenSessions: listenSessions,
	fetchData: fetchData,

	_sessions: null,
});

function init(){
	this._sessions = new Set();
	this.push({});
	this._tracker = this.dispatcher.createTracker();
}

function uninit(){
	this._tracker.off();
	this._tracker = null;
	this._sessions = null;
}

function triggers(){
	return {
		"add": add
	};
}

function listeners(){
	return {
		"connectivity:online": refresh,
		"orggroup:updated": handle_orggroup_update
	};
}

function refresh(){
	var session = setArray(this._sessions);
	this.fetchData(session);
}

function add(session){
	var sessions = this._sessions;

	if(isObject(session)) session = session.session;

	session = [].concat(session);

	session.filter(not(sessions.has.bind(sessions)));

	if(session.length){
		session.forEach(sessions.add.bind(sessions));
		this.listenSessions(session);
		return this.fetchData(session);
	} else this.extend({});
}

function listenSessions(session){
	session.map(trackSession.bind(this));
}

function trackSession(session){
	var orgGroup = this._orgGroup;
	if(!orgGroup) return;

	var tracker = this._tracker;
	tracker.on("mqtt:orggroup/" + orgGroup + "/livechat/session/" + session + "/message", handle_change.bind(this, session));
}

function handle_change(session, data){
	var newData = {};
	newData[session] = data;
	this.extend(newData);
}

function fetchData(session){
	var chunks = [];
	var total = session.length;
	var group = 0;

	while(group < total) {
		chunks.push(session.slice(group, group + MAX_AT_ONCE));
		group += MAX_AT_ONCE;
	}

	return Promise.all(chunks.map(function(chunk){
		if(!chunk.length) return [];
		return this.api.livechat.message.latestMessages(chunk);
	}, this))
		.then(flatten)
		.then(makeMap)
		.then(this.extend.bind(this))
		.catch(console.error.bind(console));
}

function flatten(list){
	return list.reduce(function (a, b) {
		return a.concat(b);
	}, []);
}

function makeMap(data){
	return data.reduce(function(acc, message){
		acc[message._id] = message.message;
		return acc;
	}, {});
}

function setArray(set){
	var result = [];
	set.forEach(function(item){
		result.push(item);
	});
	return result;
}

function handle_orggroup_update(orgGroup){
	this._orgGroup = orgGroup;
}